import i from './file-picker.field.container';

export default i;
